export class BotatoWebSocketEvent {
    public static MESSAGE = 'message';
    public static EVENT = 'event';
    public static HISTORY = 'history';
    public static CONNECT = 'connect';
    public static DISCONNECT = 'disconnect';
}
